<script lang="ts">
import type { CrystallizeImageProps } from '~/components/crystallize/Image.vue'

const paths = {
  'decagon': 'M0.658 0.0124 C0.6484 0.0054 0.6371 0.0016 0.6251 0.0016 H0.3749 C0.3629 0.0016 0.3516 0.0054 0.342 0.0124 L0.1114 0.1811 C0.1016 0.1879 0.0944 0.1984 0.0904 0.2101 L0.003 0.4821 C-0.0008 0.4937 -0.0008 0.5063 0.0029 0.5179 L0.0904 0.7899 C0.0944 0.8016 0.1016 0.8121 0.1114 0.8189 L0.342 0.9876 C0.3516 0.9946 0.3629 0.9984 0.3749 0.9984 H0.6251 C0.6371 0.9984 0.6484 0.9946 0.658 0.9876 L0.8886 0.8189 C0.8984 0.8121 0.9056 0.8016 0.9096 0.7899 L0.9971 0.5179 C1.0008 0.5063 1.0008 0.4937 0.997 0.4821 L0.9096 0.2101 C0.9056 0.1984 0.8984 0.1879 0.8886 0.1811 L0.658 0.0124 Z',
  'decagon-left': 'M1 0 H0.428 C0.4264 0 0.4247 0.0001 0.4231 0.0003 H0.2638 C0.2480 0.0003 0.2327 0.0076 0.2201 0.0213 L0.0829 0.1701 C0.0703 0.1837 0.0606 0.2030 0.0557 0.2253 L0.0036 0.4659 C-0.0014 0.4878 -0.0014 0.5113 0.0035 0.5339 L0.0557 0.7747 C0.0606 0.7970 0.0703 0.8163 0.0829 0.8299 L0.2201 0.9787 C0.2325 0.9924 0.2480 0.9997 0.2638 0.9997 H0.4231 C0.4247 0.9999 0.4264 1 0.4280 1 H1 Z',
  'decagon-right': 'M0 0 H0.572 C0.5736 0 0.5753 0.0001 0.5769 0.0003 H0.7362 C0.7520 0.0003 0.7673 0.0076 0.7799 0.0213 L0.9171 0.1701 C0.9297 0.1837 0.9394 0.2030 0.9443 0.2253 L0.9964 0.4659 C1.0014 0.4878 1.0014 0.5113 0.9965 0.5339 L0.9443 0.7747 C0.9394 0.7970 0.9297 0.8163 0.9171 0.8299 L0.7799 0.9787 C0.7675 0.9924 0.7520 0.9997 0.7362 0.9997 H0.5769 C0.5753 0.9999 0.5736 1 0.5720 1 H0 Z',
  'octagon': 'M0.773 0.0088 C0.767 0.0032 0.761 0 0.756 0 H0.244 C0.239 0 0.233 0.0032 0.228 0.0088 L0.007 0.284 C0.0032 0.289 0 0.297 0 0.305 V0.695 C0 0.703 0.0032 0.711 0.007 0.716 L0.228 0.991 C0.233 0.996 0.239 1 0.244 1 H0.756 C0.761 1 0.767 0.996 0.773 0.991 L0.993 0.716 C0.997 0.711 1 0.703 1 0.695 V0.305 C1 0.297 0.997 0.289 0.993 0.284 L0.773 0.0088 Z',
  'octagon-right': 'M0 0 H0.756 C0.761 0 0.767 0.0032 0.773 0.0088 L0.993 0.284 C0.997 0.289 1 0.297 1 0.305 V0.695 C1 0.703 0.997 0.711 0.993 0.716 L0.773 0.991 C0.767 0.996 0.761 1 0.756 1 H0 Z',
  'octagon-left': 'M1 0 H0.244 C0.239 0 0.233 0.0032 0.228 0.0088 L0.007 0.284 C0.0032 0.289 0 0.297 0 0.305 V0.695 C0 0.703 0.0032 0.711 0.007 0.716 L0.228 0.991 C0.233 0.996 0.239 1 0.244 1 H1 Z',
  'hexagon': 'M0.850 0.055 C0.833 0.021 0.797 0 0.756 0 H0.244 C0.203 0 0.167 0.021 0.150 0.055 L0.018 0.444 C0.001 0.478 0.001 0.522 0.018 0.556 L0.150 0.945 C0.167 0.979 0.203 1 0.244 1 H0.756 C0.797 1 0.833 0.979 0.850 0.945 L0.982 0.556 C0.999 0.522 0.999 0.478 0.982 0.444 L0.850 0.055 Z',
  'hexagon-left': 'M1 0 H0.244 C0.203 0 0.167 0.021 0.150 0.055 L0.018 0.444 C0.001 0.478 0.001 0.522 0.018 0.556 L0.150 0.945 C0.167 0.979 0.203 1 0.244 1 H1 Z',
  'hexagon-right': 'M0 0 H0.756 C0.797 0 0.833 0.021 0.850 0.055 L0.982 0.444 C0.999 0.478 0.999 0.522 0.982 0.556 L0.850 0.945 C0.833 0.979 0.797 1 0.756 1 H0 Z',
} as const

export type ClippedImagePath = keyof typeof paths | 'circle' | 'circle-left' | 'circle-right'

interface Props extends Omit<CrystallizeImageProps, 'hideCaption'> {
  path: ClippedImagePath
}
</script>

<script setup lang="ts">
const { path, ...props } = defineProps<Props>()

const id = useId()

const d = computed(() => path in paths ? paths[path as keyof typeof paths] : null)

const clipPath = computed(() => `url(#${id})`)
</script>

<template>
  <CrystallizeImage
    data-clipped-image
    v-bind="props"
    hide-caption
    :img-class="[
      props.imgClass,
      {
        'rounded-r-full': path === 'circle-right',
        'rounded-l-full': path === 'circle-left',
        'rounded-full': path === 'circle',
      },
    ]"
  >
    <svg v-if="d" width="0" height="0" viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <defs>
        <clipPath :id="id" clipPathUnits="objectBoundingBox">
          <path :d="d" />
        </clipPath>
      </defs>
    </svg>
  </CrystallizeImage>
</template>

<style scoped>
[data-clipped-image] {
  clip-path: v-bind(clipPath);
}
</style>
